import Ad from 'src/components/ads/Ad';
import ImageTitleAspect2_1 from 'src/components/articledisplays/ImageTitleAspect2_1';
import ImageTitleAspectSquare from 'src/components/articledisplays/ImageTitleAspectSquare';
import { isAdContent } from "src/components/forsiden/utilsv2";
import styles from './SquareWideAdBLockV2.module.css';
import { GroupedLayoutObject, IBlockWithAd, PublishableDocument } from "src/lib/types/IForsidenV2";
import IMovieList from "src/lib/types/MovieList";

//#region [Props]
type SquareWideAdBLockProps = {
	block: GroupedLayoutObject<IBlockWithAd>;
};
//#endregion

//#region [Component]
export default function SquareWideAdBLockV2({ block }: SquareWideAdBLockProps) {

	if ((block.articles?.length ?? 0) === 0) return null;
	const articles = block.articles! as Exclude<PublishableDocument, IMovieList>[];
	return <div className={styles.SSquareWideAdBLock}>
		{articles.length > 0 && <ImageTitleAspectSquare
			className={styles.SSquareArt}
			document={articles[0]}
			sizes={SIZES}
			themeValue={block.themes0}
			isContentAd={isAdContent(articles[0])}
			useSectionTitle />}

		{articles.length > 1 && <ImageTitleAspect2_1
			className={styles.SSmallArt}
			document={articles[1]}
			sizes={SIZES}
			themeValue={block.themes1}
			isContentAd={isAdContent(articles[1])}
			useSectionTitle />}
		<Ad className={styles.SAd} targetId='FW_fast_plass_forside' canHide={false} />
	</div>;
}
//#endregion

const SIZES = `(min-width: 1641px) 1640px, ((max-width: 1640px) and (min-width: 550px)) 50vw, 100vw`;

//#endregion
